import { styled } from "theme/default/styled";
import { setFlexF1 } from "theme/setter/setFlexValues/setFlexF1";

export const SRewardDetailsHeaderFilter = styled.div`
  ${setFlexF1};
`;
